export const dateMatchLevels = {
  DAY: 'day',
  YEAR: 'year',
};
